var plugin_rtlignore_default = {
  "alignLeft": "YXMqv",
  "textWrapNowrap": "msGXE",
  "alignRight": "GDGZq",
  "alignCenter": "bKRGA",
  "sizeFullWidth": "_4L8Ic",
  "renderedInTable": "Hwfyn",
  "sizeOriginal": "K54-a",
  "sizeContent": "e8WdR",
  "sizeSmall": "QqU70",
  "sizeSmallCenter": "iU2LP",
  "flex": "y068L",
  "atomic": "-O-wI",
  "anchor": "_0JHFZ",
  "embed": "_4n4mU",
  "horizontalScrollbar": "TMYSQ",
  "pluginContainerMobile": "Plai2"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
